<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">PLUGIN</h1>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-row>
        <b-col md="4" v-for="(item, index) in list" v-bind:key="index">
          <b-card no-header no-body class="m-0">
            <b-card-body>
              <div class="setting-icon">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                  right
                >
                  <template #button-content>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="20"
                      fill="currentColor"
                      class="bi bi-three-dots-vertical"
                      viewBox="0 0 15 20"
                    >
                      <path
                        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
                      />
                    </svg>
                  </template>
                  <!-- <b-dropdown-item href="#">Info</b-dropdown-item>
                  <b-dropdown-item href="#">Logs action</b-dropdown-item> -->
                  <b-dropdown-item href="#" @click="onEdit(item)"
                    >Setting</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <b-img :src="item.image" class="image-logo" />
              <div class="font-bold mt-2">{{ item.name }}</div>
              <p class="two-lines my-1">{{ item.description }}</p>
            </b-card-body>

            <b-card-footer>
              <toggle-button
                class="mt-1 mr-1 mb-0"
                :value="item.status ? true : false"
                :color="{
                  checked: '#27BDA7',
                  unchecked: '#B0B0B0',
                }"
                @change="handleChangeStatus(item)"
              />
              <span class="ml-2 f-size-18 text-header">
                {{ item.status ? "Active" : "Inactive" }}
              </span>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <ModalSettingPlugin ref="ModalSettingPlugin" @reloadData="reloadData" />
  </div>
</template>

<script>
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalSettingPlugin from "./components/ModalSettingPlugin.vue";
export default {
  name: "SettingTime",
  components: {
    ModalAlertError,
    ModalSettingPlugin,
  },
  data: function () {
    return {
      modalMessage: "",
      bodyDelete: {
        platformId: 0,
        channelId: 0,
      },
      list: []
    };
  },

  created: async function () {
    await this.getList();
  },
  methods: {
    getList: async function () {
      await this.axios.get(`${this.$baseUrl}/ThirdParty/List`).then((data) => {
        if (data.result == 1) {
          this.list = data.detail;
        }
      });
    },
    onEdit(item) {
      this.$refs.ModalSettingPlugin.onShowModal(item);
    },
    async reloadData() {
      await this.getList();
    },
    async handleChangeStatus(item) {
      await this.$store.commit("UPDATE_MAIN_LOADING", true);
      let body = {
        id: item.id,
        type: item.type,
        url: item.url,
        token: item.token,
        status: item.status ? 0 : 1,
      };
      await this.axios
        .post(`${this.$baseUrl}/ThirdParty/UpdateStatus`, body)
        .then(async (data) => {
          await this.$store.commit("UPDATE_MAIN_LOADING", false);
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: true, msg : ''});
            await this.getList();
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.card-body {
  position: relative;
}
.setting-icon {
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
}
::v-deep .setting-icon .dropdown button {
  padding: 4px;
  color: #3c4b64;
}
::v-deep .setting-icon .dropdown-menu-right {
  min-width: unset;
  padding: unset;
}
.image-logo {
  border-radius: 0.5rem;
  /* width: 75px; */
  height: 40px;
  width: auto;
  /* aspect-ratio: 1; */
}
.two-lines {
  font-size: 13px;
  color: #6b6b6b;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
